(function availableHomesFilterModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const availableHomesSortBy = global.NewHomeSource.AvailableHomesSortBy || {};

  // Get initial number of cards to display
  const initialCardsInput = document.querySelector('[data-id=initialNumberOfCardsDisplayed]');
  const initialVisibleCards = initialCardsInput && initialCardsInput.value
    ? parseInt(initialCardsInput.value, 10)
    : 8;

  // Get containers for plans and specs
  const plansContainer = document.getElementById('plans-container');
  const specsContainer = document.getElementById('specs-container');

  // Store original cards for restore
  const originalPlanCards = plansContainer ? plansContainer.querySelectorAll('[data-plan-index]') : [];
  const originalSpecCards = specsContainer ? specsContainer.querySelectorAll('[data-spec-index]') : [];

  // Make array from NodeList for easier manipulation
  const originalPlanCardsArray = Array.from(originalPlanCards);
  const originalSpecCardsArray = Array.from(originalSpecCards);

  // Get price input elements
  const minPriceInput = document.getElementById('filter-price-min');
  const maxPriceInput = document.getElementById('filter-price-max');

  // Utility to get numeric value from input, removing non-digit characters
  const getNumericValue = (input) => {
    if (input && input.value) {
      // Remove all non-digit characters
      const digits = input.value.replace(/[^\d]/g, '');
      return digits ? parseFloat(digits) : null;
    }
    return null;
  };

  // Utility to get selected price filter values
  const getSelectedPriceValues = () => {
    const minPrice = getNumericValue(minPriceInput);
    const maxPrice = getNumericValue(maxPriceInput);
    return { minPrice, maxPrice };
  };

  // Utility to get selected filter values
  const getSelectedValues = (name) => {
    const checked = Array.from(document.querySelectorAll('input[name="' + name + '"]:checked'));
    const values = checked.map((el) => el.value);
    if (values.includes('all')) {
      return []; // Empty means all selected
    }
    return values;
  };

  // Utility to show/hide the Show more/less button for a given container
  const toggleShowMoreLessButton = (container, show) => {
    const btnContainer = container.closest('[data-homes-container]');
    const btn = btnContainer ? btnContainer.querySelector('[data-more-button]') : null;
    if (btn) {
      btn.hidden = !show;

      // Count visible cards in the container
      const totalCards = Array.from(container.querySelectorAll('[data-plan-index], [data-spec-index]'));
      const totalCount = totalCards.length;
      const visibleCards = totalCards.filter((card) => !card.hidden);
      const visibleCount = visibleCards.length;

      // Use initialVisibleCards from outer scope
      if (totalCount <= initialVisibleCards) {
        btn.hidden = true;
      } else if (visibleCount > initialVisibleCards) {
        btn.textContent = 'Show less';
      } else {
        btn.textContent = 'Show more';
      }
    }
  };

  // Utility to hide cards that exceed the initial visible count
  const hideCardsGreaterThanInitial = (cards) => {
    if (!cards || cards.length === 0) {
      return;
    }
    cards.forEach((card) => {
      const thisCard = card;
      thisCard.hidden = false;
    });
    // Hide cards that exceed the initial visible count
    if (cards.length > initialVisibleCards) {
      cards.slice(initialVisibleCards).forEach((card) => {
        const thisCard = card;
        thisCard.hidden = true;
      });
    }
  };

  // Utility to check if card bedrooms match filter
  const isBedroomsMatching = (cardBedrooms, bedrooms) => {
    if (bedrooms.includes(cardBedrooms)) {
      return true;
    }
    if (bedrooms.includes('5') && parseInt(cardBedrooms, 10) >= 5) {
      return true;
    }
    return false;
  };

  // Utility to check if card bathrooms match filter
  const isBathroomsMatching = (cardBathrooms, bathrooms) => {
    if (bathrooms.includes(cardBathrooms)) {
      return true;
    }
    if (bathrooms.includes('5') && parseInt(cardBathrooms, 10) >= 5) {
      return true;
    }
    return false;
  };

  // Utility to check if card price matches filter
  const isPriceMatching = (cardPrice, minPrice, maxPrice) => {
    if (minPrice !== null && (cardPrice === null || cardPrice < minPrice)) {
      return false;
    }
    if (maxPrice !== null && (cardPrice === null || cardPrice > maxPrice)) {
      return false;
    }
    return true;
  };

  // Consolidated function to determine if a card matches filter criteria
  const isCardMatching = (card, bedrooms, bathrooms, minPrice, maxPrice) => {
    if (!card) {
      return false;
    }
    const cardBedrooms = card.getAttribute('data-bedrooms');
    const cardBathrooms = card.getAttribute('data-bathrooms');
    const cardPriceRaw = card.getAttribute('data-price');
    const cardPrice = cardPriceRaw ? parseFloat(cardPriceRaw.replace(/[$,]/g, '')) : null;

    // Bedrooms filter
    if (bedrooms.length > 0 && !isBedroomsMatching(cardBedrooms, bedrooms)) {
      return false;
    }
    // Bathrooms filter
    if (bathrooms.length > 0 && !isBathroomsMatching(cardBathrooms, bathrooms)) {
      return false;
    }
    // Price filter
    if (!isPriceMatching(cardPrice, minPrice, maxPrice)) {
      return false;
    }

    return true;
  };

  // Updates the filter button active state and applied count badge
  const updateFiltersButtonState = () => {
    const btn = document.getElementById('avail-homes-filters-button');
    const badge = document.getElementById('filters-applied-count');
    if (!btn || !badge) {
      return;
    }

    let activeCount = 0;

    // Price group: min or max price entered
    const { minPrice, maxPrice } = getSelectedPriceValues();
    if (minPrice !== null || maxPrice !== null) {
      activeCount += 1;
    }

    // Bedrooms group: any checked except 'all'
    if (getSelectedValues('bedrooms').length > 0) {
      activeCount += 1;
    }

    // Bathrooms group: any checked except 'all'
    if (getSelectedValues('bathrooms').length > 0) {
      activeCount += 1;
    }

    // Set .active class and badge
    if (activeCount > 0) {
      btn.classList.add('nhs-c-button--active');
      badge.textContent = activeCount;
      badge.hidden = false;
    } else {
      btn.classList.remove('nhs-c-button--active');
      badge.textContent = '';
      badge.hidden = true;
    }
  };

  // Utility to filter and remove cards from DOM (only called on Apply)
  const filterAndRemoveCards = (container, cardSelector, bedrooms, bathrooms, minPrice, maxPrice) => {
    // Validate input parameters
    if (!container || !cardSelector || !Array.isArray(bedrooms) || !Array.isArray(bathrooms)) {
      return;
    }

    // Get all card elements within the container
    const cards = Array.from(container.querySelectorAll(cardSelector));
    if (!cards || cards.length === 0) {
      // No cards found, hide the Show more/less button
      toggleShowMoreLessButton(container, false);
      return;
    }
    const filteredCards = [];

    // Iterate over each card to determine if it should be shown or removed
    cards.forEach((card) => {
      if (isCardMatching(card, bedrooms, bathrooms, minPrice, maxPrice)) {
        filteredCards.push(card);
      } else {
        card.parentNode.removeChild(card);
      }
    });

    hideCardsGreaterThanInitial(filteredCards);

    // Show or hide the Show more/less button based on the number of visible cards
    toggleShowMoreLessButton(container, filteredCards.length > initialVisibleCards);
  };

  // Restore all cards to DOM
  const restoreAllCards = (toggleShowMoreLess) => {
    if (plansContainer) {
      plansContainer.querySelectorAll('[data-plan-index]').forEach((card) => {
        card.remove();
      });
      originalPlanCards.forEach((card) => {
        plansContainer.appendChild(card);
      });
      hideCardsGreaterThanInitial(Array.from(plansContainer.children));
      if (toggleShowMoreLess) {
        toggleShowMoreLessButton(plansContainer, true);
      }
    }
    if (specsContainer) {
      specsContainer.querySelectorAll('[data-spec-index]').forEach((card) => {
        card.remove();
      });
      originalSpecCards.forEach((card) => {
        specsContainer.appendChild(card);
      });
      hideCardsGreaterThanInitial(Array.from(specsContainer.children));
      if (toggleShowMoreLess) {
        toggleShowMoreLessButton(specsContainer, true);
      }
    }
  };

  // Update count display for each container
  const updateContainerCounts = () => {
    const plansCount = plansContainer ? plansContainer.querySelectorAll('[data-plan-index]').length : 0;
    const specsCount = specsContainer ? specsContainer.querySelectorAll('[data-spec-index]').length : 0;

    const plansCountElem = document.querySelector('[data-plans-count]');
    if (plansCountElem) {
      plansCountElem.textContent = plansCount;
    }
    const specsCountElem = document.querySelector('[data-specs-count]');
    if (specsCountElem) {
      specsCountElem.textContent = specsCount;
    }
  };

  // Replace the filter logic in updateFilterCount to use the reusable function
  const updateFilterCount = () => {
    const bedrooms = getSelectedValues('bedrooms');
    const bathrooms = getSelectedValues('bathrooms');
    const minPrice = getSelectedPriceValues().minPrice;
    const maxPrice = getSelectedPriceValues().maxPrice;

    const plansCount = originalPlanCardsArray
      .filter((card) => isCardMatching(card, bedrooms, bathrooms, minPrice, maxPrice)).length;
    const specsCount = originalSpecCardsArray
      .filter((card) => isCardMatching(card, bedrooms, bathrooms, minPrice, maxPrice)).length;

    const total = plansCount + specsCount;
    const filterCountElem = document.getElementById('filterCount');
    if (filterCountElem) {
      filterCountElem.textContent = total;
    }

    const applyBtn = document.querySelector('[data-apply]');
    if (applyBtn) {
      applyBtn.disabled = total === 0;
      if (total === 0) {
        applyBtn.setAttribute('title', 'No homes match your filter criteria');
      } else {
        applyBtn.removeAttribute('title');
      }
    }
    // Do NOT call updateContainerCounts here
  };

  const sortByMostRecentOrder = () => {
    // Sort cards in each container using global function if available
    if (typeof availableHomesSortBy.sortCards === 'function') {
      if (plansContainer && plansContainer.id) {
        availableHomesSortBy.sortCards(plansContainer.id, availableHomesSortBy.mostRecentSortBy);
        requestAnimationFrame(() => {
          plansContainer.scroll({
            left: 0,
            behavior: 'smooth'
          }); // Reset scroll position to the start
        });
      }
      if (specsContainer && specsContainer.id) {
        availableHomesSortBy.sortCards(specsContainer.id, availableHomesSortBy.mostRecentSortBy);
        requestAnimationFrame(() => {
          specsContainer.scroll({
            left: 0,
            behavior: 'smooth'
          }); // Reset scroll position to the start
        });
      }
    }
  };

  // Helper to format value as $X,XXX
  const formatPriceValue = (value) => {
    if (!value) {
      return '';
    }
    // Remove all non-digit characters
    const num = value.replace(/[^\d]/g, '');
    if (!num) {
      return '';
    }
    // Limit to 8 digits
    const limitedNum = num.slice(0, 8);
    // Format as currency
    return '$' + parseInt(limitedNum, 10).toLocaleString();
  };

  // Restrict input to 0-9, comma, $
  const restrictInput = (event) => {
    const allowed = /[\d,$]/;
    if (!allowed.test(event.key) && event.key.length === 1) {
      event.preventDefault();
    }
    // Prevent entering more than 8 digits
    const input = event.target;
    const value = input.value.replace(/[^\d]/g, '');
    // Allow navigation keys
    const navigationKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
    ];
    if (navigationKeys.includes(event.key)) {
      return;
    }
    if (value.length >= 8 && /\d/.test(event.key)) {
      event.preventDefault();
    }
  };

  // Validate min/max price relationship and clear as needed
  const validateMinMaxPrice = () => {
    const minPriceVal = minPriceInput.value.replace(/[^\d]/g, '');
    const maxPriceVal = maxPriceInput.value.replace(/[^\d]/g, '');
    const minPrice = minPriceVal ? parseInt(minPriceVal, 10) : null;
    const maxPrice = maxPriceVal ? parseInt(maxPriceVal, 10) : null;

    if (minPrice !== null && maxPrice !== null) {
      if (maxPrice < minPrice) {
        maxPriceInput.value = '';
      } else if (minPrice > maxPrice) {
        minPriceInput.value = '';
      }
    }
    updateFilterCount();
  };

  // Open the link when card is clicked
  const openCardLink = (event) => {
    const target = event.target;
    const card = target.closest('[data-standard-card]');
    if (!card) {
      return;
    }

    if (target.closest('[data-favorite-trigger]')) {
      return;
    }

    const link = card.querySelector('[data-link]');
    if (!link) {
      return;
    }

    if (link === target) {
      return;
    }

    window.open(link.href, '_blank');
  };

  /**
  * Price inputs change handler
  *
  * @function
  * @returns {void}
  */
  //
  const handlePriceInputs = () => {
    // Attach listeners to price inputs
    [minPriceInput, maxPriceInput].forEach((input) => {
      if (!input) {
        return;
      }

      let updateTimeout;

      input.addEventListener('keydown', restrictInput);

      input.addEventListener('input', () => {
        const inputElement = input;
        inputElement.value = formatPriceValue(input.value);
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => {
          validateMinMaxPrice();
        }, 1000);
      });

      input.addEventListener('blur', () => {
        clearTimeout(updateTimeout);
        const inputElement = input;
        inputElement.value = formatPriceValue(input.value);
        validateMinMaxPrice();
      });

      input.addEventListener('change', () => {
        validateMinMaxPrice();
      });
    });
  };

  /**
  * Bed / Bath inputs change handler
  *
  * @function
  * @returns {void}
  */
  //
  // Helper function to handle bed/bath filter change logic
  const handleBedBathFilterChange = (input) => {
    const group = input.name;
    const allInput = document.getElementById(group + '_all');
    const checked = Array.from(document.querySelectorAll('input[name="' + group + '"]:checked'));
    if (input.value === 'all' && input.checked) {
      document.querySelectorAll('input[name="' + group + '"]').forEach((element) => {
        const thisElement = element;
        if (thisElement.value !== 'all') {
          thisElement.checked = false;
        }
      });
    } else {
      allInput.checked = checked.length === 0;
    }
    updateFilterCount();
  };

  const handleBedBathInputs = () => {
    // Event listeners for filter inputs (only update counts, do not remove cards)
    const filterInputs = document.querySelectorAll('input[name="bedrooms"], input[name="bathrooms"]');
    filterInputs.forEach((input) => {
      input.addEventListener('change', () => handleBedBathFilterChange(input));
    });
  };

  const handleCardClicks = () => {
    if (plansContainer) {
      plansContainer.addEventListener('click', openCardLink);
    }
    if (specsContainer) {
      specsContainer.addEventListener('click', openCardLink);
    }
  };

  /**
  * Clear filters click
  *
  * @function
  * @returns {void}
  */
  //
  const applyFilterHandler = () => {
    const bedrooms = getSelectedValues('bedrooms');
    const bathrooms = getSelectedValues('bathrooms');
    const minPrice = getSelectedPriceValues().minPrice;
    const maxPrice = getSelectedPriceValues().maxPrice;

    restoreAllCards(false);

    filterAndRemoveCards(plansContainer, '[data-plan-index]', bedrooms, bathrooms, minPrice, maxPrice);
    filterAndRemoveCards(specsContainer, '[data-spec-index]', bedrooms, bathrooms, minPrice, maxPrice);

    sortByMostRecentOrder();
    updateContainerCounts();

    updateFiltersButtonState();

    // Close the modal/panel
    const panelToggle = document.getElementById('avail-homes-filters-toggle');
    if (panelToggle) {
      panelToggle.checked = false;
      panelToggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  /**
  * Initializes Apply filters button
  *
  * @function
  * @returns {void}
  */
  //
  const handleApplyFiltersButton = () => {
    const applyBtn = document.querySelector('[data-apply]');
    if (!applyBtn) {
      return;
    }
    applyBtn.removeEventListener('click', applyFilterHandler);
    applyBtn.addEventListener('click', applyFilterHandler);
  };

  /**
  * Clear filters click
  *
  * @function
  * @returns {void}
  */
  //
  const clearButtonHandler = () => {
    ['bedrooms', 'bathrooms'].forEach((group) => {
      document.querySelectorAll('input[name="' + group + '"]').forEach((element) => {
        const thisElement = element;
        thisElement.checked = (thisElement.value === 'all');
      });
    });
    minPriceInput.value = '';
    maxPriceInput.value = '';

    restoreAllCards(true);

    sortByMostRecentOrder();
    updateContainerCounts();

    updateFilterCount();
    updateFiltersButtonState();
  };

  /**
  * Initializes Clear filters button (restores cards and updates container counts)
  *
  * @function
  * @returns {void}
  */
  //
  const handleClearButton = () => {
    const clearButton = document.querySelector('[data-advanced-clear-filters]');
    if (!clearButton) {
      return;
    }
    clearButton.removeEventListener('click', clearButtonHandler);
    clearButton.addEventListener('click', clearButtonHandler);
  };

  /**
  * Initializes keyboard activation for the filters panel labels
  *
  * The open/close controls are <label> elements with role="button", which are
  * not natively keyboard-operable, so toggle the associated checkbox on
  * Enter/Space (the labels already handle pointer clicks).
  *
  * @function
  * @returns {void}
  */
  //
  const handleFiltersPanelKeyboard = () => {
    const panelToggle = document.getElementById('avail-homes-filters-toggle');
    if (!panelToggle) {
      return;
    }

    const panel = document.getElementById('avail-homes-filters-panel');

    // The closed panel is only visually hidden, so its controls would stay in
    // the tab order. Mark it inert/aria-hidden while closed.
    const setPanelOpenState = (isOpen) => {
      if (!panel) {
        return;
      }
      if (isOpen) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    };

    const setPanelState = (isOpen) => {
      panelToggle.checked = isOpen;
      panelToggle.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const isActivationKey = (event) => event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar';

    const openButton = document.getElementById('avail-homes-filters-button');
    if (openButton) {
      openButton.setAttribute('aria-expanded', panelToggle.checked ? 'true' : 'false');
      openButton.addEventListener('keydown', (event) => {
        if (!isActivationKey(event)) {
          return;
        }
        event.preventDefault();
        setPanelState(!panelToggle.checked);
      });
    }

    const closeButton = document.querySelector('[data-panel-option="avail-homes-filters-close"]');
    if (closeButton) {
      closeButton.addEventListener('keydown', (event) => {
        if (!isActivationKey(event)) {
          return;
        }
        event.preventDefault();
        setPanelState(false);
      });
    }

    panelToggle.addEventListener('change', () => {
      setPanelOpenState(panelToggle.checked);
      if (openButton) {
        openButton.setAttribute('aria-expanded', panelToggle.checked ? 'true' : 'false');
      }
      if (panelToggle.checked) {
        if (closeButton) {
          closeButton.focus();
        }
      } else if (openButton) {
        openButton.focus();
      }
    });

    setPanelOpenState(panelToggle.checked);
  };

  handlePriceInputs();
  handleBedBathInputs();
  handleApplyFiltersButton();
  handleClearButton();
  handleFiltersPanelKeyboard();

  // Initial filter count
  updateFilterCount();

  handleCardClicks();
}(window));
